export default __webpack_public_path__ + "static/media/pro-elevate-red-2.93ce10e8.png";